import fx from "utils/fx";
import AxiosInterceptor from "api/interceptor";

const gst = new AxiosInterceptor();

export default {
  getAll(qstr = {}) {
    qstr = fx.urlQueryString(qstr, false);
    return gst.get("/gst?" + qstr);
  },
  find(id) {
    return gst.get("/gst/" + id);
  },
  create(data) {
    return gst.post("/gst", data);
  },
  update(id, data) {
    data.value = data.value.toString();
    return gst.put("/gst/" + id, data);
  },
  delete(id, replacedID) {
    const data = { replace_id: replacedID };
    return gst.delete("/gst/" + id, { data });
  }
};
